const HTML_EMPTY_PARAGRAPH_REGEX = /<p>\s*<\/p>/g;
/**
 * According to the quill-editor's issue
 * https://github.com/quilljs/quill/issues/1915
 */
const QUILL_EDITOR_HTML_CURSOR = /(<(strong|u)>)?<span class="ql-cursor">[^<]*<\/span>(<\/(strong|u)>)?/g;
const HTML_EMPTY_ROW = '<p><br></p>';
const HTML_PARAGRAPH_CONTENT_REGEX = /<p>(.*?)<\/p>/g;

export function trimEmptyHtmlRows(html: string): string {
  if (!html) {
    return '';
  }

  return html
    .trim()
    .replace(QUILL_EDITOR_HTML_CURSOR, '')
    .replace(HTML_EMPTY_PARAGRAPH_REGEX, HTML_EMPTY_ROW)
    .split(HTML_EMPTY_ROW)
    .filter(Boolean)
    .join(HTML_EMPTY_ROW)
    .replace(HTML_PARAGRAPH_CONTENT_REGEX, (_, content: string) => `<p>${content.trim()}</p>`);
}
